import Big from 'big.js';

interface SignedAmountProps {
    amount: number | null | undefined;
    format: (amount: number | Big | null | undefined) => string;
    strong?: boolean;
}

/** Importe que se resalta cuando resta (anulaciones, créditos). */
export default function SignedAmount({ amount, format, strong }: SignedAmountProps) {
    if (amount != null && amount < 0) {
        return <span className="md-amount-negative">{format(amount)}</span>;
    }
    return strong ? <strong>{format(amount)}</strong> : <>{format(amount)}</>;
}
